import { type RegisteredRouter, useRouterState } from '@tanstack/react-router';
import type { FileRouteTypes } from '@/routeTree.gen';

/**
 * The three legal pages on each site, which the banner's own links lead to, and the live counter, a wall
 * display. Route ids, not paths: slugs are translated, and a rename breaks the build instead of
 * re-admitting the banner. docs/notes/portals/use-banner-free-route.md
 */
export const BANNER_FREE_ROUTE_IDS: readonly FileRouteTypes['id'][] = [
	'/$portalId/legal-disclaimer',
	'/$portalId/privacy-policy',
	'/old/cookies',
	'/old/legal-disclaimer',
	'/old/privacy-policy',
	'/www/cookies',
	'/www/legal-disclaimer',
	'/www/live-counter',
	'/www/privacy-policy',
];

/**
 * From the router's matches, so it follows client-side navigation. Effects only, never markup, so it
 * cannot make server and client disagree.
 */
export const useBannerFreeRoute = (): boolean =>
	useRouterState<RegisteredRouter, boolean>({
		select: (state) => state.matches.some((match) => BANNER_FREE_ROUTE_IDS.some((id) => id === match.routeId)),
	});
